import DistanceRange from '../../../components/filter_aside/distance_range.js';
import DistanceToShore from '../../../components/filter_aside/distance_to_shore.js';
import FilterCondition from '../../../components/filter_aside/filter_condition.js.jsx';
import PricesRange from '../../../components/filter_aside/prices_range.js';
import ServiceTags from '../../../components/filter_desktop/service_tags.js.jsx';
import {
  BASE_CATEGORY_ID,
  FISHING_CATEGORY_ID,
  GLAMPING_CATEGORY_ID,
  GUEST_HOUSE_CATEGORY_ID,
  HOTEL_CATEGORY_ID,
  HUNTING_CATEGORY_ID,
  IS_SANATORIUMS,
  PANSION_CATEGORY_ID,
  SANATORII_CATEGORY_ID,
} from '../../../components/filter_main.js.jsx';
import FilterAside from '../../../components/filter_mobile/filter_aside.js.jsx';

export default class SanatoriumsFilterAside extends FilterAside {
  constructor(props) {
    super(props);
  }

  render() {

    const treatmentProfilesEnter = () => {
      if (!this.state.isMouseEntered) {
        this.setState({ isMouseEntered: true });
      }
    };

    let prices = !this.props.is_foreign ? (
      <PricesRange
        filter={this.filter}
        title={'Цена'}
        prices={this.props.filters.prices}
        initPrices={this.props.initPrices}
        max_end={this.props.price_max_end}
        filterValue='prices'
      />
    ) : undefined;

    let promotions =
      this.props.data.camp_promotions && this.props.data.camp_promotions.length > 0 ? (
        <ServiceTags
          service_name={'Акции'}
          condition_param={'campPromotions'}
          filter={this.filter}
          value={this.props.filters.campPromotions}
          campServiceTags={this.props.data.camp_promotions}
        />
      ) : undefined;

    const waters = this.props.data.waters?.length > 0 && (
      <FilterCondition
        condition_name={'Водоемы поблизости'}
        condition_param={'waters'}
        orMode
        filter={this.filter}
        enabled_ids={this.props.filters.waters}
        condition_items={this.props.data.waters}
        counts={this.props.filters_counts?.waters}
      />
    );
    const filter_categories = this.props.filter_values.categories;
    const shouldDisplayTreatment =
      IS_SANATORIUMS ||
      (filter_categories.length > 0 &&
        filter_categories.every((category) => [SANATORII_CATEGORY_ID, PANSION_CATEGORY_ID].includes(category)));

    const treatmentTags = Array.isArray(this.props.data.camp_treatment_profiles) ?
      this.props.data.camp_treatment_profiles :
      [];
    let treatmentProfiles =
      shouldDisplayTreatment &&
      treatmentTags.length > 0 ? (
        <ServiceTags
          service_name={'Профили лечения'}
          condition_param={'campTreatmentProfiles'}
          filter={this.filter}
          value={this.props.filters.campTreatmentProfiles}
          campServiceTags={treatmentTags}
          counts={this.props.filters_counts?.camp_service_tags}
        />
      ) : undefined;

    let shoreRange =
      this.props.data.shore_distances && this.props.data.shore_distances.length > 1 ? (
        <DistanceToShore
          filter={this.filter}
          value={this.props.filters.shoreDistance}
          counts={this.props.filters_counts?.shoreDistance}
          shore_distances={this.props.data.shore_distances}
        />
      ) : undefined;

    const filteredTagsProperties = this.state.filteredTagsProperties;

    const tagsProperties = filteredTagsProperties.length > 0 && (
      <FilterCondition
        condition_name={'Услуги'}
        condition_param={'tags_properties'}
        filter={this.filter}
        enabled_ids={this.props.filters.tags_properties}
        condition_items={filteredTagsProperties}
        filtered_all_categories={'true'}
        counts={this.props.filters_counts?.camp_service_tags}
      />
    );

    let serviceTags =
      this.props.data.camp_service_tags && this.props.data.camp_service_tags.length > 0 ? (
        <ServiceTags
          service_name={'Услуги'}
          condition_param={'campServiceTags'}
          filter={this.filter}
          value={this.props.filters.campServiceTags}
          campServiceTags={
            this.props.user_show_filter
              ? this.props.data.camp_service_tags_for_manager
              : this.props.data.camp_service_tags
          }
          hide_service_name={this.state.filteredTagsProperties.length > 0 ? 'true' : ''}
          user_show_filter={this.props.user_show_filter}
          counts={this.props.filters_counts?.camp_service_tags}
        />
      ) : undefined;

    let categoryForKids =
      this.props.data.childcare_tags && this.props.data.childcare_tags.length > 0 ? (
        <ServiceTags
          service_name={'Для детей'}
          condition_param={'childcareTags'}
          filter={this.filter}
          value={this.props.filters.childcareTags}
          campServiceTags={this.props.data.childcare_tags}
          counts={this.props.filters_counts?.camp_service_tags}
        />
      ) : undefined;

    let locations =
      this.props.data.camp_locations && this.props.data.camp_locations.length > 0 ? (
        <ServiceTags
          service_name={'Расположение'}
          condition_param={'campLocations'}
          filter={this.filter}
          orMode
          value={this.props.filters.campLocations}
          campServiceTags={this.props.data.camp_locations}
          counts={this.props.filters_counts?.camp_service_tags}
        />
      ) : undefined;

    let areaCenterRange = this.props.data.area_center ? (
      <DistanceRange
        filter={this.filter}
        default_distance={this.props.data.default_distance || this.props.data.max_distance}
        max_distance={this.props.data.max_distance}
        value={this.props.filters.distance}
        title={`От ${this.props.data.city_name_genitive ?? this.props.data.area_center}`}
        distanceInteraction={this.distanceInteraction}
        filterValue='distance'
      />
    ) : undefined;

    let stars =
      this.props.data.stars && this.props.data.stars.length > 0 ? (
        <FilterCondition
          condition_name={'Количество звезд'}
          condition_param={'stars'}
          filter={this.filter}
          orMode
          enabled_ids={this.props.filters.stars}
          condition_items={this.props.data.stars}
          counts={this.props.filters_counts?.stars}
        />
      ) : undefined;

    let districts =
      this.props.districts?.length > 0 ? (
        <FilterCondition
          condition_name={'Районы'}
          condition_param={'districts'}
          filter={this.filter}
          orMode
          enabled_ids={this.props.filters.districts}
          condition_items={this.props.districts}
        />
      ) : undefined;

    const poolList = this.props.data.swimming_pools_properties;

    const swimmingPoolsProperties = poolList?.length > 0 && this.props.data.visible_blocks_filters.pools && (
        <FilterCondition
          condition_name={'Бассейн'}
          condition_param={'swimming_pools_properties'}
          filter={this.filter}
          orMode
          enabled_ids={this.props.filters.swimming_pools_properties}
          condition_items={poolList}
          counts={this.props.filters_counts?.swimming_pools_properties}
        />
      );

    let bathhouses =
      this.props.data.camp_bathhouses &&
      this.props.data.camp_bathhouses.length > 0 &&
      this.props.data.visible_blocks_filters.baths ? (
        <ServiceTags
          service_name={'Бани и сауны'}
          condition_param={'bathTags'}
          filter={this.filter}
          orMode
          value={this.props.filters.bathTags}
          campServiceTags={this.props.data.camp_bathhouses}
          counts={this.props.filters_counts?.bathTags}
        />
      ) : undefined;

    let treatment_profiles_tags =
      shouldDisplayTreatment &&
      this.props.data.treatment_profiles_tags &&
      this.props.data.treatment_profiles_tags.length > 0 ? (
        <ServiceTags
          service_name={'Лечебный фактор'}
          condition_param={'campTreatmentFactors'}
          filter={this.filter}
          value={this.props.filters.campTreatmentFactors}
          campServiceTags={this.props.data.treatment_profiles_tags}
          counts={this.props.filters_counts?.camp_service_tags}
        />
      ) : null;

    let recovery = shouldDisplayTreatment && (
      <FilterCondition
        condition_name={'Оздоровление'}
        condition_param={'recovery'}
        filter={this.filter}
        enabled_ids={this.props.filters.recovery}
        condition_items={this.props.data.recovery}
      />
    );

    const {
      props: {
        data: { category_list: dataCategoryList, project },
      },
    } = this;

    // Формируем categoryList
    let categoryList;
    if (project === 'kurortix.ru') {
      const desiredIds = [6, 7, 8]; // Санатории (6), Пансионаты (7), Отели (8)

      // Фильтруем категории и переименовываем "Отели" в "СПА отели"
      categoryList = dataCategoryList
        .filter((item) => desiredIds.includes(item.id))
        .map((item) => (item.id === 8 ? { ...item, name: 'СПА отели' } : item));

      // Порядок: Санатории, Пансионаты, СПА отели
      const order = {
        6: 1, // Санатории
        7: 2, // Пансионаты
        8: 3, // СПА отели
      };

      // Сортируем категории по заданному порядку
      categoryList.sort((a, b) => order[a.id] - order[b.id]);
    } else {
      const orderCategoriesUb = {
        [HOTEL_CATEGORY_ID]: 1, // Отели
        [GUEST_HOUSE_CATEGORY_ID]: 2, // Гостевые дома
        [BASE_CATEGORY_ID]: 3, // Базы отдыха
        [GLAMPING_CATEGORY_ID]: 4, // Глэмпинги
        [SANATORII_CATEGORY_ID]: 5, // Санатории
        [PANSION_CATEGORY_ID]: 6, // Пансионаты
        [FISHING_CATEGORY_ID]: 7, // Рыболовные базы
        [HUNTING_CATEGORY_ID]: 8, // Охотничьи базы
      };

      console.log(this.state.filteredCategoryTypes)

      categoryList = dataCategoryList;
      categoryList.sort((a, b) => orderCategoriesUb[a.id] - orderCategoriesUb[b.id]);
    }

    const filteredAllCategories = this.state.filteredAllCategories.length > 0;

    const category = (
      <FilterCondition
        condition_name={'Категория'}
        condition_param={'categories'}
        filter={this.filter}
        orMode
        enabled_ids={this.props.filters.categories}
        condition_items={categoryList}
        counts={this.props.filters_counts?.categories}
        withoutDivider={filteredAllCategories}
      />
    );

    const allCategories = filteredAllCategories &&
      <FilterCondition condition_name={''}
                       condition_param={'all_enabled_categories'}
                       filter={this.filter}
                       orMode
                       enabled_ids={this.props.filters.all_enabled_categories}
                       condition_items={this.state.filteredAllCategories}
                       counts={this.props.filters_counts?.all_categories}
                       withoutTopPadding={true}
      />

    const food = (
      <FilterCondition
        condition_name={'Тип питания'}
        condition_param={'foodTypes'}
        filter={this.filter}
        enabled_ids={this.props.filters.foodTypes}
        counts={this.props.filters_counts?.foodTypes}
        condition_items={this.props.data.food_types}
      />
    );

    let legend =
      this.props.showManagerMap && !this.props.listShowMode ? (
        <div className='filter-row'>
          <div className='filter-row__title'>Легенда</div>
          <p>Есть места:</p>
          <p>
            <div className='manager-placemark_layout brown' /> - 0 броней
          </p>
          <p>
            <div className='manager-placemark_layout brown-green' /> - 1 бронь
          </p>
          <p>
            <div className='manager-placemark_layout green-brown' /> - 2-4 брони
          </p>
          <p>
            <div className='manager-placemark_layout green' /> - более 4 броней
          </p>
          <p>Нет мест:</p>
          <p>
            <div className='manager-placemark_layout light-gray' /> - 0 броней
          </p>
          <p>
            <div className='manager-placemark_layout gray' /> - 1-4 брони
          </p>
          <p>
            <div className='manager-placemark_layout dark-gray' /> - более 4 броней
          </p>
        </div>
      ) : undefined;

    return (
      <form id='filter' className='aside-filter filter' onMouseEnter={treatmentProfilesEnter}>
        <div className='filter-row__container'>
          <FilterCondition
            condition_name={''}
            condition_param={'instant'}
            filter={this.filter}
            enabled_ids={this.props.filters.instant}
            condition_items={this.props.data.instant}
          />
          {
            (this.props.filters_counts?.discount > 0 || this.props.filters.discount) && (
              <FilterCondition
                condition_name={''}
                condition_param={'discount'}
                filter={this.filter}
                enabled_ids={this.props.filters.discount}
                condition_items={this.props.data.discount}
              />
            )
          }
          <FilterCondition
            condition_name={''}
            condition_param={'notRequiredPrepayment'}
            filter={this.filter}
            enabled_ids={this.props.filters.notRequiredPrepayment}
            condition_items={this.props.data.notRequiredPrepayment}
          />
          {this.props.datesChosen && this.props.total_guests_count > 3 && (
            <FilterCondition
              condition_name={''}
              condition_param={'singleRoom'}
              filter={this.filter}
              enabled_ids={this.props.filters.singleRoom}
              condition_items={this.props.data.singleRoom}
            />
          )}
        </div>

        {promotions}

        {category}

        {allCategories}

        {prices}

        {stars}

        {swimmingPoolsProperties}

        {bathhouses}

        {recovery}

        {treatment_profiles_tags}

        {this.state.isMouseEntered ? treatmentProfiles : null}

        {food}

        {tagsProperties}

        {serviceTags}

        {categoryForKids}

        {areaCenterRange}

        {shoreRange}

        {districts}

        {waters}

        {locations}

        {legend}
      </form>
    );
  }
}
